import { Directive, forwardRef } from '@angular/core';
import { Validator, NG_VALIDATORS, FormControl } from '@angular/forms';

@Directive({
  selector: '[PostalcodeValidator][ngModel], [PostalcodeValidator][formControl],  [PostalcodeValidator][formControlName]',
  providers: [
    { provide: NG_VALIDATORS, useExisting: forwardRef(() => PostalcodeValidator), multi: true }
  ]
})
export class PostalcodeValidator implements Validator {

  validate(c: FormControl): { [key: string]: any } {
    if (c.value == 'hola') {
      return null;
    }
    return {
      postalCode: {
        valid: false
      }
    };
  }

}



// WEBPACK FOOTER //
// ./src/app/core/component/core/validatos/postalcode.validator.ts